import { Component, ChangeDetectorRef } from "@angular/core";
import { PaymentMethodItem } from "../../interfaces/interfaces";
import { ApiService } from '../../services/api.service';
import { DialogService } from 'primeng/dynamicdialog';
import { SimpleTableComponent } from "../../generals/Components";
import { PaymentMethodEditorComponent } from "../paymentmethodeditor/paymentmethodeditor.component";
import { filter } from "rxjs/operators";

@Component({
    selector: 'app-paymentmethods',
    templateUrl: './paymentmethods.component.html'
})
export class PaymentMethodsComponent extends SimpleTableComponent<PaymentMethodItem> {
    constructor(
      private apiServiceRef: ApiService,
      private dialogService: DialogService,
      private changeDetectionRef: ChangeDetectorRef
    ) {
      super(changeDetectionRef, apiServiceRef);
      this.endPoint = 'paymentmethods';
    }
    showPaymentMethodEditorModal(paymentMethodItem: PaymentMethodItem): void {
      this.dialogService.open(PaymentMethodEditorComponent, {
        header: paymentMethodItem.title,
        data: {
          id: paymentMethodItem.id
        }
      }).onClose.pipe(filter((rsp) => rsp !== undefined && rsp === true)).subscribe(() => {
        this.refreshTable();
      });
    }
}
